import { InputAdornment } from '@material-ui/core'
import styled from 'styled-components'

export const StyledInputAdornment = styled(InputAdornment)`
  p {
    color: ${({ disabled }) => (disabled ? '#ededed' : '')};
  }
`
